export class paymenttncCMSModel {
    paymenttersmandconditions: any;
}


export class paymenttncEntryIdObj {
  	entryIds = [
      { id:'3DU1H1HELfatX7c28MWDoz', text : 'paymenttersmandconditions'}
  	];
}